import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { CulturalActivity } from "@common/ADAPT.Common.Model/organisation/cultural-activity";
import { IDxPopoverEvent } from "@common/ux/dx.types";
import { CulturalActivityService } from "@org-common/lib/cultural-activity/cultural-activity.service";
import { CulturalActivityMetadataByType } from "@org-common/lib/cultural-activity/cultural-activity-type-metadata";
import { DxPopoverComponent } from "devextreme-angular/ui/popover";
import { lastValueFrom } from "rxjs";

@Component({
    selector: "adapt-activity-rescheduled-info",
    templateUrl: "./activity-rescheduled-info.component.html",
    standalone: false,
})
export class ActivityRescheduledInfoComponent implements OnInit {
    @Input({ required: true }) public activity!: CulturalActivity;
    @Input() public showOriginalDate = true;

    @Input() public tooltipTarget?: HTMLElement;

    public popoverVisible = false;
    public popoverCancelHiding = false;

    @ViewChild(DxPopoverComponent) private popoverComponent?: DxPopoverComponent;

    public get culturalActivityTypeMetadata() {
        return CulturalActivityMetadataByType[this.activity.type];
    }

    public constructor(private culturalActivityService: CulturalActivityService) {}

    public async ngOnInit() {
        // attempt to fetch suppData
        await lastValueFrom(this.culturalActivityService.getCulturalActivitySupplementaryData(this.activity));
    }

    // handling the case where description is too longer than we need s scroll view
    // - has to prevent the popover from going away if pointer moved to the popover content
    //   and cancel hiding
    public preventHide() {
        this.popoverComponent?.instance.option("visible", true);
        this.popoverCancelHiding = true;
        this.popoverVisible = true;
    }

    public allowHide() {
        this.popoverCancelHiding = false;
        this.popoverVisible = false;
    }

    public onPopoverHiding(e: IDxPopoverEvent) {
        if (this.popoverCancelHiding) {
            e.cancel = true;
        }
    }
}
